"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.monthsFromToday = exports.getFormattedLastDateChangedPassword = exports.getDateStringFromTimestamp = exports.getAnalyticsDateStringFromTimestamp = exports.daysFromToday = void 0;
var _format = _interopRequireDefault(require("date-fns/format"));
var _zhCN = _interopRequireDefault(require("date-fns/locale/zh-CN"));
const getDateStringFromTimestamp = _ref => {
  let {
    timestamp,
    locale,
    time = false,
    utc = false
  } = _ref;
  if (!timestamp) return '';
  let timestampDate = new Date(timestamp);
  if (utc) {
    timestampDate = new Date(timestampDate.getTime() + 60000 * timestampDate.getTimezoneOffset());
  }
  const options = {};
  if (locale === 'zh') {
    options.locale = _zhCN.default;
  }
  let formatString;
  if (locale === 'zh') {
    formatString = time ? 'yyyy年MM月dd日HH时mm分' : 'yyyy年MM月dd日';
  } else {
    formatString = time ? 'dd-MMM-yy HH:mm' : 'dd-MMM-yy';
  }
  const dateString = (0, _format.default)(timestampDate, formatString, options);
  return dateString;
};
exports.getDateStringFromTimestamp = getDateStringFromTimestamp;
const getAnalyticsDateStringFromTimestamp = timestamp => (0, _format.default)(new Date(timestamp), 'yy-MM-dd');
exports.getAnalyticsDateStringFromTimestamp = getAnalyticsDateStringFromTimestamp;
const daysFromToday = days => {
  const to = new Date();
  const from = new Date(to.getTime());
  from.setDate(to.getDate() - days);
  return {
    to,
    from
  };
};
exports.daysFromToday = daysFromToday;
const monthsFromToday = months => {
  const to = new Date();
  const from = new Date(to.getTime());
  from.setMonth(to.getMonth() - months);
  return {
    to,
    from
  };
};
exports.monthsFromToday = monthsFromToday;
const formatDay = day => parseInt(day, 10) > 9 ? day : day.slice(1);
const getFormattedLastDateChangedPassword = (date, locale) => {
  const months = {
    'en': ['Ian', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    'zh': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
  };
  const dateArray = date.split('-');
  const year = dateArray[0];
  const day = formatDay(dateArray[2].slice(0, 2));
  const dayZh = ['1', '2', '11', '31'].includes(day) ? "".concat(day, "\u65E5") : day;
  const month = months[locale][parseInt(dateArray[1], 10) - 1];
  if (locale === 'zh') {
    return "".concat(year, "\u5E74").concat(month).concat(dayZh);
  }
  return "".concat(day, " ").concat(month, " ").concat(year);
};
exports.getFormattedLastDateChangedPassword = getFormattedLastDateChangedPassword;